const API_BASE = typeof window === 'undefined'
  ? 'http://backend:8000'
  : 'http://localhost:8001'
export async function fetchArticles(params?: {
  category?: string
  page?: number
  limit?: number
  sort?: string
}) {
  const query = new URLSearchParams()
  if (params?.category) query.set('category', params.category)
  if (params?.page) query.set('page', String(params.page))
  if (params?.limit) query.set('limit', String(params.limit))
  if (params?.sort) query.set('sort', params.sort)

  const res = await fetch(`${API_BASE}/api/articles/?${query}`, {
    cache: 'no-store'
  })
  if (!res.ok) throw new Error('Failed to fetch articles')
  return res.json()
}

export async function fetchArticle(id: string) {
  const res = await fetch(`${API_BASE}/api/articles/${id}`, {
    cache: 'no-store'
  })
  if (!res.ok) throw new Error('Article not found')
  return res.json()
}

export async function fetchEntities(params?: {
  entity_type?: string
  page?: number
}) {
  const query = new URLSearchParams()
  if (params?.entity_type) query.set('entity_type', params.entity_type)
  if (params?.page) query.set('page', String(params.page))

  const res = await fetch(`${API_BASE}/api/entities/?${query}`, {
    cache: 'no-store'
  })
  if (!res.ok) throw new Error('Failed to fetch entities')
  return res.json()
}

export async function fetchStats() {
  const res = await fetch(`${API_BASE}/api/admin/stats`, {
    cache: 'no-store'
  })
  if (!res.ok) throw new Error('Failed to fetch stats')
  return res.json()
}

export async function login(email: string, password: string) {
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  })
  if (!res.ok) throw new Error('Invalid credentials')
  return res.json()
}

export async function register(
  email: string,
  password: string,
  full_name: string
) {
  const res = await fetch(`${API_BASE}/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password, full_name })
  })
  if (!res.ok) throw new Error('Registration failed')
  return res.json()
}